var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBscActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.61,
    height: 21.471,
    viewBox: "0 0 21.61 21.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.003,
    y1: 0.503,
    x2: 1.004,
    y2: 0.503,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3416b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e45f48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.001,
    y1: 0.499,
    x2: 0.995,
    y2: 0.499,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bsc_acive",
    transform: "translate(-220.59 -214.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bscscan-logo-circle_00000043449361733721667680000013945243733398485127_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1_00000024718439100246853090000007363735654262128011_",
    d: "M225.1,225a.9.9,0,0,1,.9-.9h1.5a.9.9,0,0,1,.9.9h0v5.7c.2-.1.4-.1.6-.2a.858.858,0,0,0,.6-.7v-7.1a.9.9,0,0,1,.9-.9H232a.9.9,0,0,1,.9.9v6.6a4.537,4.537,0,0,1,.8-.3.752.752,0,0,0,.5-.7v-7.9a.9.9,0,0,1,.9-.9h1.5a.9.9,0,0,1,.9.9v6.5a20.274,20.274,0,0,0,3.7-3.5,1.4,1.4,0,0,0,.2-1.4,10.635,10.635,0,0,0-13.6-6.6,10.756,10.756,0,0,0-6.6,13.6,14.166,14.166,0,0,0,.8,1.8,1.457,1.457,0,0,0,1.3.7c.3,0,.6-.1,1.1-.1a.773.773,0,0,0,.7-.8V225",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2_00000155132281528031047970000015911015403182870715_",
    d: "M225.1,234.2a10.817,10.817,0,0,0,17.1-8.7v-.7c-4,5.8-11.3,8.6-17.1,9.4",
    fill: "url(#linear-gradient-2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscActive);
export default __webpack_public_path__ + "static/media/bsc_active.5b76248c633f3b026f0a29e60340b94b.svg";
export { ForwardRef as ReactComponent };